export const BOOKING_LINK = 'https://crystalcanine.btystk.com/';
